import React from 'react'

const Wishlist = () => {
  return (
    <div>
      {/* <Product /> */}
    </div>
  )
}

export default Wishlist
